<template>
  <div id="SectionXBRL">
    <UIContainer class="SectionXBRL__container">
      <div class="SectionXBRL__content">
        <h2 class="SectionXBRL__title">
          Ingest, govern, evidence & disclose with Sustainalyse.
        </h2>

        <p class="SectionXBRL__description">
          From utilities and invoices to supplier attestations and iXBRL - one
          governed pipeline.
        </p>
      </div>

      <div class="SectionXBRL__cta">
        <UIButton size="xl" :to="{ name: 'Contact' }"> Book a demo </UIButton>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionXBRL {
  background-color: $color-ui-gray-cool-100;
  .SectionXBRL__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 2.5rem;

    @include md {
      flex-direction: row;
      padding: 3rem 5rem;
    }
  }

  .SectionXBRL__title {
    @include font-size-30px();
    color: $color-ui-gray-cool-800;
    font-weight: 600;
    margin-bottom: 1.25rem;
  }

  .SectionXBRL__description {
    @include font-size-18px();
    color: $color-ui-gray-cool-800;
  }

  .SectionXBRL__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem;

    @include md {
      margin-top: 0;
    }
  }
}
</style>
